import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
// import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import CreditCardPlastic from './credit-card-plastic'

import LoadingButton from "@mui/lab/LoadingButton";
const CreditCardCardinfo = ({ handleStepCardInfo, state, valuesCard, setValuesCard, handleInputChangeCard, isValidCardForm  }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
		>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				sx={{
					marginTop: '80px'
				}}
			>
				<CreditCardPlastic 
				state={state}
				valuesCard={valuesCard}
				handleInputChangeCard={handleInputChangeCard}
				setValuesCard={setValuesCard}
				/>
			</Box>
			<LoadingButton
				loading={false}
				type="submit"
				sx={{
					backgroundColor: colors.greenAccent[600],
					width: isNonMobile ? "50%" : "95%",
					borderRadius: "60px",
					marginTop: "20px"
				}}
				variant="contained"
				onClick={handleStepCardInfo}
				disabled={!isValidCardForm}
				name="submit-btn-plastic"
			>
				Avançar
			</LoadingButton>
		</Box>
	);
};

export default CreditCardCardinfo;
